/*******************************************************************************
  LocationDropdown.js

  Author: Advait; 

*******************************************************************************/
import React, { useState, useEffect, useRef } from "react";
import "../../../index.css";

function LocationDropdown({ locations, onSelect, currentLocationName }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (index) => {
    onSelect(index);
    setIsOpen(false);
  };

  if (locations.length <= 1) {
    return (
      <div className="visual-tour-location-name-static">
        <span className="visual-tour-location-name-text">{currentLocationName}</span>
      </div>
    );
  }

  return (
    <div ref={dropdownRef}>
      <div
        className="visual-tour-location-name-clickable"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="visual-tour-location-name-text">{currentLocationName}</span>
        <span className={`visual-tour-dropdown-arrow ${isOpen ? "open" : ""}`}></span>
      </div>
      {isOpen && (
        <div className="visual-tour-location-dropdown-menu">
          {locations.map((location, index) => (
            <div
              key={index}
              className="visual-tour-location-dropdown-item"
              onClick={() => handleSelect(index)}
            >
              {location.url ? (
                <img
                  crossOrigin="anonymous"
                  src={location.url}
                  alt={location.name}
                  className="visual-tour-thumbnail"
                />
              ) : (
                <div className="visual-tour-thumbnail placeholder">
                  <span>X</span>
                </div>
              )}
              <span>{location.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LocationDropdown;
